import { Box, Typography } from '@mui/material';

/**
 * The wireframes' question layout: the question text above the input, a red asterisk
 * when required, gray helper text under the question, and an error line under the
 * input. No shared equivalent exists elsewhere in the app (Hart's FormField uses
 * floating labels), so inputs inside should be label-less (`hiddenLabel`).
 */
export default function QuestionField({ label, required = false, helper, error, children }) {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.75 }}>
      <Typography variant="body1" sx={{ fontWeight: 500, color: 'text.dark', lineHeight: 1.5 }}>
        {label}
        {required && (
          <Box component="span" sx={{ color: 'error.main', ml: 0.25 }}>
            *
          </Box>
        )}
      </Typography>
      {helper && (
        <Typography variant="caption" sx={{ color: 'text.secondary', lineHeight: 1.5, mt: -0.25 }}>
          {helper}
        </Typography>
      )}
      {children}
      {error && (
        <Typography variant="caption" sx={{ color: 'error.main' }}>
          {error}
        </Typography>
      )}
    </Box>
  );
}
